<script lang="ts">
    import InputWrapper from './InputWrapper.svelte';

    export let id: string;
    export let label: string;
    export let value: string = null;
    export let customClass: string = '';
    export let inline: boolean = false;
</script>

<InputWrapper id={id} label={label} inline={inline} customClass={customClass}>
    <input
        type="date"
        id={id}
        class="form-control"
        bind:value
    />
</InputWrapper>